import { dpAssert } from "@/sharedTypes/helpers";
import { ACTIVE_COLOR } from "@/sharedTypes/coreTypes";
import { ManagerEntity } from "@/shared/globalFunctions";

export const editNoteColor = "orange"

class SheetEditorColoring {
    selectedNoteElement: Element | undefined
    coloredElements: any[] = [];
    selectNote(noteElement: Element) {
        dpAssert(ManagerEntity.renderer)

        if (this.selectedNoteElement) {
            ManagerEntity.renderer.changeElementColor(this.selectedNoteElement, ACTIVE_COLOR)
            this.coloredElements.push(this.selectedNoteElement)
        }

        this.selectedNoteElement = noteElement;
        ManagerEntity.renderer.changeElementColor(this.selectedNoteElement, editNoteColor)
        this.coloredElements.push(this.selectedNoteElement)

    }
    resetAllColoringElements() {
        this.coloredElements.forEach((el: any) => {
            if (ManagerEntity.renderer) {
                ManagerEntity.renderer.changeElementColor(el, ACTIVE_COLOR);
            } else {
                throw new Error("Tried to change color note, but there's no ManagerEntity.renderer");
            }
        })
        this.coloredElements.length = 0;
    }
}

export default SheetEditorColoring